import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard } from '@shapeable/ui';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`

    /* override title styles via BEM here to affect spacing */ 
    .shp--page-layout-standard__title {
      font-family: ${theme.FONT('heading')};
      font-weight: 300;
      line-height: 0.9em;
      letter-spacing: -0.04em;
      max-width: 700px;
      margin-bottom: 32px;
      
      strong {
        font-weight: 700;
      }
    }

    .shp--page-layout-standard__subtitle {
      font-weight: 200;

      strong {
        font-weight: 700;
      }
    }
  `,
  tablet: css`
    .shp--banner-titles {
      width: 100%;
    }
  `,
  desktop: css`
    .shp--banner-titles {
        
    }
  `
});

// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutHome: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  return (
    <My.Layout 
      entity={entity}
      slices={slices}
      headerProps={{ 
        showOverlayGradient: true, 
        variant: 'overlay', 
        backgroundColor: '#000000',
        fadeColor: '#0000000', 
       }}
      className={className}
    />
  )
};
